import { applyLeadAnalyticsUser, getAnalyticsIdentityForAuth } from './analyticsService';
import { HONEYPOT_FIELD_NAME } from '../components/HoneypotField';

const CHAT_LEADS_URL = 'https://tophamtechbe.com/api/treas/idx/v1/chatleads';
const API_KEY = 'treas-api-key-2025';

const createSuppressedLeadResponse = () => {
  const payload = { accepted: true };
  return {
    ok: true,
    status: 200,
    statusText: 'OK',
    honeypotBlocked: true,
    json: async () => payload,
    clone: createSuppressedLeadResponse
  };
};

const toSearchParams = (values) => {
  if (values instanceof URLSearchParams) return values;

  const params = new URLSearchParams();
  Object.entries(values || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null) params.set(key, value);
  });
  return params;
};

const requestChatLeads = async (values, method) => {
  const params = toSearchParams(values);
  if (method === 'POST' && params.get(HONEYPOT_FIELD_NAME)?.trim()) {
    console.info('Lead submission suppressed by spam protection.');
    return Promise.resolve(createSuppressedLeadResponse());
  }

  const options = { method, headers: { 'X-API-Key': API_KEY } };
  if (method === 'POST') {
    const analyticsIdentity = await getAnalyticsIdentityForAuth();
    if (analyticsIdentity) {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify({ analyticsIdentity });
    }
  }
  const response = await fetch(`${CHAT_LEADS_URL}?${params}`, options);
  if (method === 'POST' && response.ok && response.clone) {
    try { applyLeadAnalyticsUser((await response.clone().json())?.analyticsUserId); } catch { /* Best effort. */ }
  }
  return response;
};

export const submitChatLead = (values) => requestChatLeads(values, 'POST');
export const getChatLeads = (values) => requestChatLeads(values, 'GET');

